import React, { Component } from 'react';
import logo from './logo.svg';
import './Trade.css';
import {
  Navbar,
  Nav,
  NavItem,
  Grid,
  Row,
  Col,
  Panel,
  Button
} from 'react-bootstrap';
import { CustomNav } from '../Components/CustomNav';
import { PlayerCard } from '../Components/PlayerCard';
import {
  getHenriColor,
  getHenriStyle,
  getCapColour,
  makeNRData,
  round
} from '../Utility/utility.js';
import axios from 'axios';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { AppContext } from '../Pages/App';
import { FadeLoader } from 'react-spinners';
import Decimal from 'decimal';
import Popover from 'react-simple-popover';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions, jwtTeam, jwtInfo } from '../_helpers';
import { ScenarioHeader } from '../Components/ScenarioHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlusSquare,
  faTimes,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons';
const uuidv4 = require('uuid/v4');

//var randomWords = require('random-words');
var randomWords = require('../Utility/generateWords.js');

let prospects = require('../Mock/trade-team-one-prospects.json');
let teamOne = require('../Mock/trade-team-one.json');
let picks = require('../Mock/trade-team-one-picks.json');

export class Trade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      teamOne: [],
      teamOneAssets: [],
      teamOneCap: [],
      teamOneOutcome: [],
      teamOneOutgoing: ['', '', '', '', ''],
      teamOneAssetType: 'player',
      teamTwo: [],
      teamTwoAssets: [],
      teamTwoCap: [],
      teamTwoOutcome: [],
      teamTwoOutgoing: ['', '', '', '', ''],
      teamTwoAssetType: 'player',
      selectedAsset: [],
      selectedPlayer: '',
      homeTeam: jwtTeam(),
      awayTeam: 'ANA',
      termLength: 1,
      teamOneColumns: this.playerColumns,
      teamTwoColumns: this.playerColumns,
      teamOnePageSize: 26,
      teamTwoPageSize: 26,
      savedTrade: [],
      open: false,
      openLoad: false,
      openSave: false,
      saved_trades: [],
      currentTrade: [],
      tradeLoading: false,
      tradeName: ''
    };
    this.activateLasers = this.activateLasers.bind(this);
    this.saveTrade = this.saveTrade.bind(this);
    this.openSaveTrade = this.openSaveTrade.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.loadTrade = this.loadTrade.bind(this);
    this.loadTrades = this.loadTrades.bind(this);
    this.addAsset = this.addAsset.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleteamTwoAssetTypeChange = this.handleteamTwoAssetTypeChange.bind(
      this
    );
    this.handleteamOneAssetTypeChange = this.handleteamOneAssetTypeChange.bind(
      this
    );
    //  this.toggleConference = this.toggleConference.bind(this);
  }

  componentDidMount() {
    let currentComponent = this;
    axios
      .all([
        axios.get(
          apiServerUrl + '/trade_assets?team=' + this.state.homeTeam,
          requestOptions()
        ),
        axios.get(
          apiServerUrl + '/trade_assets?team=' + this.state.awayTeam,
          requestOptions()
        )
      ])
      .then(
        axios.spread((homeRes, awayRes) => {
          //console.log(homeRes.data);
          //console.log(awayRes.data);
          if (homeRes.data && awayRes.data) {
            currentComponent.setState({
              teamOneAssets: homeRes.data.team_assets,
              teamOneCap: homeRes.data.team_cap,
              teamOneAll: homeRes.data,
              teamTwoAssets: awayRes.data.team_assets,
              teamTwoCap: awayRes.data.team_cap,
              teamTwoAll: awayRes.data
            });
            this.recalculate();
          }
        })
      );
  }
  handleChange2(e) {
    const { name, value } = e.target;
  }

  handleChange(e, item, index, incomingTeam) {
    const { name, value } = e.target;
    console.log(e, item, index, incomingTeam, name, value);
    if (incomingTeam === 1) {
      console.log('team one');
      let oldIncoming = this.state.teamOneOutgoing;
      oldIncoming[index].retained = parseInt(value);
      console.log(oldIncoming[index]);
      this.setState(prevState => ({
        teamOneOutgoing: oldIncoming
      }));
    } else if (incomingTeam === 2) {
      console.log('incoming team is 2');
      let oldIncoming = this.state.teamTwoOutgoing;
      oldIncoming[index].retained = parseInt(value);
      this.setState(prevState => ({
        teamTwoOutgoing: oldIncoming
      }));
    }
    console.log('recalulating');
    this.recalculate();
    return;
  }
  /*  handleChange(e) {
      const { name, value } = e.target;
      this.setState({ [name]: value });
    }
*/
  async addSpaces(theArray) {
    for (let i = 0; i < 5; i++) {
      if (!theArray[i]) {
        theArray[i] = '';
      }
    }
    return theArray;
  }
  async getTeam(value, team, grouped) {
    console.log('change team' + value);
    let currentComponent = this;
    let url = apiServerUrl + '/trade_assets?team=' + value;
    // Make a request for a user with a given ID
    let answer = await axios
      .get(url, requestOptions())
      .then(async function(response) {
        console.log('logging response');
        console.log(response);
        return response.data;
      })
      .catch(async function(error) {
        console.log(error);
      });
    return answer;
  }

  async getTradeInfo(trade) {
    let url = apiServerUrl + '/get_trade?trade_id=' + trade.trade_id;
    let answer = await axios
      .get(url, requestOptions())
      .then(function(response) {
        console.log(response.data);
        return response.data;
      })
      .catch(function(error) {
        //console.log(error);
      });
    return answer;
  }

  async addRetainedValues(OutgoingCleaned, tradeInfo) {
    for (let i = 0; i < OutgoingCleaned.length; i++) {
      console.log('value' + JSON.stringify(OutgoingCleaned[i]));
      var found = tradeInfo.find(function(element) {
        if (OutgoingCleaned[i].asset_type == 'pick') {
          return element.id == OutgoingCleaned[i].pick_id;
        } else {
          return element.id == OutgoingCleaned[i].player_id;
        }
      });
      console.log(found);
      OutgoingCleaned[i].retained = found.retained;
    }
    return OutgoingCleaned;
  }
  async mapIdsToPlayers(teamIDs, team) {
    let cleanedArray = [];
    for (let i = 0; i < teamIDs.length; i++) {
      var found = team.team_assets.find(function(element) {
        console.log('element');
        console.log(element);
        console.log('teamIDs[i]');
        console.log(teamIDs[i]);
        //NEED TO ADD ASSET TYPE MATCH HERE
        if (element.asset_type == 'pick') {
          return element.pick_id == teamIDs[i].id;
        } else {
          return element.player_id == teamIDs[i].id;
        }
      });

      if (found) {
        //Add in the retained salary value from the saved trade
        cleanedArray[i] = found;
      }
    }
    return cleanedArray;
  }
  async loadTrade(trade, sample) {
    console.log('loading trade' + JSON.stringify(trade));
    let currentComponent = this;
    currentComponent.setState({
      tradeLoading: true
    });
    let tradeInfo = await currentComponent.getTradeInfo(trade);
    let teamOne = await currentComponent.getTeam(
      tradeInfo.trade_info.teamOne.teamID,
      'home',
      true
    );
    let teamTwo = await currentComponent.getTeam(
      tradeInfo.trade_info.teamTwo.teamID,
      'away',
      true
    );

    //catch some nulls and clean
    let teamOneOutgoingCleaned = await this.mapIdsToPlayers(
      tradeInfo.trade_info.teamOne.outgoingAssets,
      teamOne
    );
    let teamOneOutgoingRetained = await this.addRetainedValues(
      teamOneOutgoingCleaned,
      tradeInfo.trade_info.teamOne.outgoingAssets
    );
    let teamOneOutgoingSpaced = await this.addSpaces(teamOneOutgoingRetained);
    let teamTwoOutgoingCleaned = await this.mapIdsToPlayers(
      tradeInfo.trade_info.teamTwo.outgoingAssets,
      teamTwo
    );
    let teamTwoOutgoingRetained = await this.addRetainedValues(
      teamTwoOutgoingCleaned,
      tradeInfo.trade_info.teamTwo.outgoingAssets
    );
    let teamTwoOutgoingSpaced = await this.addSpaces(teamTwoOutgoingRetained);

    console.log(teamOne);

    await currentComponent.setState({
      teamOneOutgoing: teamOneOutgoingSpaced,
      teamTwoOutgoing: teamTwoOutgoingSpaced,
      homeTeam: tradeInfo.trade_info.teamOne.teamID,
      awayTeam: tradeInfo.trade_info.teamTwo.teamID,
      teamOneAssets: teamOne.team_assets,
      teamTwoAssets: teamTwo.team_assets
    });
    console.log('loading trade before calc');

    this.recalculate();
    currentComponent.setState({
      openLoad: false,
      tradeLoading: false
    });
    console.log('loaded trade');
  }

  loadTrades() {
    let currentComponent = this;
    let url = apiServerUrl + '/saved_trades';
    axios
      .get(url, requestOptions())
      .then(function(response) {
        console.log(response);
        console.log(response.data);
        currentComponent.setState({
          saved_trades: response.data
        });
      })
      .catch(function(error) {
        //console.log(error);
      });

    currentComponent.setState({ openLoad: !this.state.openLoad });
  }

  openSaveTrade() {
    let currentComponent = this;
    currentComponent.setState({ openSave: !this.state.openSave });
  }
  saveTrade() {
    let currentComponent = this;
    console.log('INGOING OUTGOING');
    console.log(this.state.teamOneOutgoing);
    console.log(this.state.teamTwoOutgoing);
    console.log(this.state.tradeName);

    //generate a date-guid as a default name
    var d = new Date();
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();

    let newdate = year + '/' + month + '/' + day;
    let user = jwtInfo();
    //console.log(user);
    let tradeDesc =
      user.identity.name +
      '-' +
      this.state.homeTeam +
      '-' +
      this.state.awayTeam +
      '-' +
      newdate;
    let players = [];
    let trade = {};
    let trade_info = {};
    let teamOne = {};
    let teamTwo = {};

    //Only default if no name given
    this.state.tradeName
      ? (trade.trade_desc = this.state.tradeName)
      : (trade.trade_desc = tradeDesc);
    //trade.trade_desc = tradeDesc;
    console.log('trade nmae is' + trade.trade_desc);
    //Assemble Team One
    teamOne.teamID = this.state.homeTeam;
    teamOne.outgoingAssets = this.state.teamOneOutgoing;
    //Assemble Team Two
    teamTwo.teamID = this.state.awayTeam;
    teamTwo.outgoingAssets = this.state.teamTwoOutgoing;

    trade_info.teamOne = teamOne;
    trade_info.teamTwo = teamTwo;

    trade.trade_info = trade_info;
    console.log('trade is');
    console.log(trade);

    axios
      .post(apiServerUrl + '/save_trade', { trade: trade }, requestOptions())
      .then(function(response) {
        console.log(response);
      })
      .catch(function(error) {
        console.log(error);
      });
    currentComponent.setState({ openSave: !this.state.openSave });
  }
  changeTeam(value, team, grouped) {
    let currentComponent = this;
    let url = apiServerUrl + '/trade_assets?team=' + value;
    axios
      .get(url, requestOptions())
      .then(function(response) {
        if (grouped) {
          return response;
        }
        if (team === 'home') {
          currentComponent.setState({
            homeTeam: value,
            teamOneAssets: response.data.team_assets,
            teamOneCap: response.data.team_cap
          });
        } else if (team === 'away') {
          currentComponent.setState({
            awayTeam: value,
            teamTwoAssets: response.data.team_assets,
            teamTwoCap: response.data.team_cap
          });
        }
        console.log('about to recalc from chagetream');
        currentComponent.recalculate();
      })
      .catch(function(error) {
        //console.log(error);
      });
  }

  playerColumns = [
    {
      Header: 'Player',
      id: 'player',
      accessor: d => [d.first_name, ' ', d.last_name],
      Cell: row => (
        <div>
          {' '}
          {(this.state.teamOneAssets[row.index].league === 'LTIR ' &&
            this.state.teamOneAssets[row.index].first_name == row.value[0]) ||
          (this.state.teamTwoAssets[row.index].league === 'LTIR ' &&
            this.state.teamTwoAssets[row.index].first_name == row.value[0]) ? (
            <FontAwesomeIcon
              style={{
                color: 'red',
                fontSize: '22px',
                paddingLeft: '0px',
                paddingTop: '0px'
              }}
              icon={faPlusSquare}
            />
          ) : (
            ''
          )}
          {row.value}
        </div>
      ),
      minWidth: 130,
      filterMethod: (filter, row) => {
        return (
          row[filter.id][0].toLowerCase().includes(filter.value) ||
          row[filter.id][2].toLowerCase().includes(filter.value)
        );
      }
    },
    {
      Header: 'Age',
      accessor: 'age',
      id: 'age',
      minWidth: 40
    },
    {
      Header: 'POS',
      id: 'position',
      accessor: d => d.position,
      minWidth: 40
    },
    {
      Header: 'CAP HIT',
      id: 'cap',
      defaultSortDesc: true,
      sortMethod: (a, b, desc) => {
        a =
          a.split('m').length > 1
            ? a.split('m')[0] * 1000
            : a.split('k')[0] * 1;
        b =
          b.split('m').length > 1
            ? b.split('m')[0] * 1000
            : b.split('k')[0] * 1;
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      accessor: d => (d.contract[0] ? round(d.contract[0].cap_hit) : null),
      minWidth: 70
    },
    {
      Header: 'HENRI',
      id: 'henri',
      defaultSortDesc: true,
      sortMethod: (a, b, desc) => {
        a =
          a === null
            ? desc
              ? -Infinity
              : Infinity
            : a.split('m').length > 1
              ? a.split('m')[0] * 1000
              : a.split('k')[0] * 1;
        b =
          b === null
            ? desc
              ? -Infinity
              : Infinity
            : b.split('m').length > 1
              ? b.split('m')[0] * 1000
              : b.split('k')[0] * 1;
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      accessor: d => (d.contract[0] ? round(d.contract[0].henri) : null),
      minWidth: 70
    },
    {
      Header: 'SURPLUS',
      id: 'surplus',
      defaultSortDesc: true,
      sortMethod: (a, b, desc) => {
        a =
          a === null
            ? desc
              ? -Infinity
              : Infinity
            : a.split('m').length > 1
              ? a.split('m')[0] * 1000
              : a.split('k')[0] * 1;
        b =
          b === null
            ? desc
              ? -Infinity
              : Infinity
            : b.split('m').length > 1
              ? b.split('m')[0] * 1000
              : b.split('k')[0] * 1;
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      accessor: d => (d.contract[0] ? round(d.contract[0].surplus) : null),
      minWidth: 70
    }
  ];
  pickColumns = [
    {
      Header: 'Year',
      id: 'year',
      accessor: d => d.draft_year,
      minWidth: 50
    },
    {
      Header: 'Round',
      accessor: d => d.round,
      id: 'round',
      minWidth: 60
    },
    {
      Header: 'Team',
      id: 'team',
      accessor: d => d.orig_team,
      minWidth: 60
    },
    {
      Header: 'HENRI',
      id: 'henri',
      accessor: d => (d.contract[0] ? round(d.contract[0].henri) : null),
      defaultSortDesc: true,
      sortMethod: (a, b, desc) => {
        a =
          a === null
            ? desc
              ? -Infinity
              : Infinity
            : a.split('m').length > 1
              ? a.split('m')[0] * 1000
              : a.split('k')[0] * 1;
        b =
          b === null
            ? desc
              ? -Infinity
              : Infinity
            : b.split('m').length > 1
              ? b.split('m')[0] * 1000
              : b.split('k')[0] * 1;
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      minWidth: 60
    },
    {
      Header: 'Condition Detail',
      id: 'detail',
      accessor: d => d.condition_detail,
      minWidth: 180
    }
  ];

  modifyTerm(choice, example) {
    if (choice) {
      this.setState({
        termLength: choice
      });
    }
  }

  getAssetDescription(item) {
    if (item.first_name) {
      return item.first_name + ' ' + item.last_name;
    } else if (item.draft_year) {
      return item.orig_team + '   ' + item.draft_year + ' Round ' + item.round;
    } else {
      return '  ';
    }
  }
  activateLasers(item) {
    this.setState(prevState => ({
      selectedAsset: item
    }));
    let currentComponent = this;
    if (!item.player_id) {
      return;
    }
    axios
      .get(
        apiServerUrl + '/player_card?player_id=' + item.player_id,
        requestOptions()
      )
      .then(function(response) {
        //console.log(response.data);
        if (response.data) {
          currentComponent.setState({
            selectedPlayer: response.data
          });
        }
      })
      .catch(function(error) {
        //console.log(error);
      });
  }
  handleteamTwoAssetTypeChange(event) {
    if (event.target.value === 'pick') {
      this.setState({
        teamTwoAssetType: event.target.value,
        teamTwoColumns: this.pickColumns,
        teamTwoPageSize: this.state.teamOneAssets.filter(
          x => x.asset_type === 'pick'
        ).length
      });
    } else if (event.target.value === 'prospect') {
      this.setState({
        teamTwoAssetType: event.target.value,
        teamTwoColumns: this.playerColumns,
        teamTwoPageSize: this.state.teamOneAssets.filter(
          x => x.asset_type === 'prospect'
        ).length
      });
    } else {
      this.setState({
        teamTwoAssetType: event.target.value,
        teamTwoColumns: this.playerColumns,
        teamTwoPageSize: this.state.teamOneAssets.filter(
          x => x.asset_type === 'player'
        ).length
      });
    }
  }
  handleteamOneAssetTypeChange(event) {
    if (event.target.value === 'pick') {
      this.setState({
        teamOneAssetType: event.target.value,
        teamOneColumns: this.pickColumns,
        teamOnePageSize: this.state.teamOneAssets.filter(
          x => x.asset_type === 'pick'
        ).length
      });
    } else if (event.target.value === 'prospect') {
      this.setState({
        teamOneAssetType: event.target.value,
        teamOneColumns: this.playerColumns,
        teamOnePageSize: this.state.teamOneAssets.filter(
          x => x.asset_type === 'prospect'
        ).length
      });
    } else {
      this.setState({
        teamOneAssetType: event.target.value,
        teamOneColumns: this.playerColumns,
        teamOnePageSize: this.state.teamOneAssets.filter(
          x => x.asset_type === 'player'
        ).length
      });
    }
  }

  projectedRemainingCalc(player, days_remaining) {
    let capHit = 0;
    console.log(player);
    if (player.roster_group === 'ACTIVE ROSTER') {
      console.log('active');
      console.log('cap hit' + player.daily_cap_hit);
      console.log('days_remaining ' + days_remaining);
      capHit = Math.round(player.daily_cap_hit) * days_remaining;
      console.log(' result' + capHit);
    } else if (player.roster_group == 'NON-ROSTER') {
      capHit = Math.round(player.buried_daily_cap_hit) * days_remaining;
    } else if (player.roster_group == 'SOIR DETAILS') {
      capHit = Math.round(player.soir_daily_cap_hit) * days_remaining;
    } else if (player.roster_group == 'RESERVE') {
      capHit = 0;
    }
    return capHit;
  }

  async recalculateYearOne() {
    console.log('recalculate');
    let teamOneOutcome = this.state.teamOneOutcome;
    let teamTwoOutcome = this.state.teamTwoOutcome;
    let year = 0;
    //cap_ceiling - cap + ltir_used
    console.log(this.state.teamOneCap[year].cap);
    console.log(this.state.teamTwoCap[year].cap);
    console.log(this.state.teamOneAll.days_remaining);

    //Calculate henri and SURPLUS
    const teamOneOutgoingHenri = this.state.teamOneOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        currentPost.contract &&
        currentPost.contract[year] &&
        currentPost.contract[year].henri
          ? totalUpvotes - currentPost.contract[year].henri
          : totalUpvotes, // reducer function
      0 // initial accumulator value
    );
    //Calculate henri and SURPLUS
    const teamTwoOutgoingHenri = this.state.teamTwoOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        currentPost.contract &&
        currentPost.contract[year] &&
        currentPost.contract[year].henri
          ? totalUpvotes - currentPost.contract[year].henri
          : totalUpvotes, // reducer function
      0 // initial accumulator value
    );
    const teamOneOutgoingSurplus = this.state.teamOneOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        currentPost.contract &&
        currentPost.contract[year] &&
        currentPost.contract[year].surplus
          ? totalUpvotes - currentPost.contract[year].surplus
          : totalUpvotes, // reducer function
      0 // initial accumulator value
    );
    const teamTwoOutgoingSurplus = this.state.teamTwoOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        currentPost.contract &&
        currentPost.contract[year] &&
        currentPost.contract[year].surplus
          ? totalUpvotes - currentPost.contract[year].surplus
          : totalUpvotes, // reducer function
      0 // initial accumulator value
    );

    //calculate cap hit and RETAINED
    const teamOneOutgoingRetained = this.state.teamOneOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        currentPost.retained && currentPost.retained
          ? totalUpvotes + currentPost.retained
          : totalUpvotes, // reducer function
      0 // initial accumulator value
    );
    const teamTwoOutgoingRetained = this.state.teamTwoOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        currentPost.retained && currentPost.retained
          ? totalUpvotes + currentPost.retained
          : totalUpvotes, // reducer function
      0 // initial accumulator value
    );
    const teamOneOutgoingCap = this.state.teamOneOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        currentPost.contract &&
        currentPost.contract[year] &&
        currentPost.contract[year].cap_hit
          ? totalUpvotes + currentPost.contract[year].cap_hit
          : totalUpvotes, // reducer function
      0 // initial accumulator value
    );
    const teamTwoOutgoingCap = this.state.teamTwoOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        currentPost.contract &&
        currentPost.contract[year] &&
        currentPost.contract[year].cap_hit
          ? totalUpvotes + currentPost.contract[year].cap_hit
          : totalUpvotes, // reducer function
      0 // initial accumulator value
    );

    //Calculate the outgoing projected remaining for team one
    const teamOneOutgoingProjectedRemaining = this.state.teamOneOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        totalUpvotes +
        this.projectedRemainingCalc(
          currentPost,
          this.state.teamOneAll.days_remaining
        ), // reducer function
      0 // initial accumulator value
    );
    console.log(
      'total after teamOneOutgoingProjectedRemaining reduce ' +
        teamOneOutgoingProjectedRemaining
    );
    //Calculate the outgoing projected remaining for team two
    const teamTwoOutgoingProjectedRemaining = this.state.teamTwoOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        totalUpvotes +
        this.projectedRemainingCalc(
          currentPost,
          this.state.teamTwoAll.days_remaining
        ), // reducer function
      0 // initial accumulator value
    );

    //Equation for pro-rated retained salary is:
    //(`retained amount` / `days_in_season`) * `days_remaining`
    let teamOneOutgoingProjectedRetained = this.state.teamOneOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        currentPost.retained && currentPost.retained
          ? totalUpvotes +
            (currentPost.retained / this.state.teamOneAll.days_in_season) *
              this.state.teamOneAll.days_remaining
          : totalUpvotes, // reducer function
      0 // initial accumulator value
    );
    teamOneOutgoingProjectedRetained = Math.round(
      teamOneOutgoingProjectedRetained
    );
    //console.log()
    console.log(
      'teamOneOutgoingProjectedRetained' + teamOneOutgoingProjectedRetained
    );
    let teamTwoOutgoingProjectedRetained = this.state.teamTwoOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        currentPost.retained && currentPost.retained
          ? totalUpvotes +
            (currentPost.retained / this.state.teamTwoAll.days_in_season) *
              this.state.teamTwoAll.days_remaining
          : totalUpvotes, // reducer function
      0 // initial accumulator value
    );
    teamTwoOutgoingProjectedRetained = Math.round(
      teamTwoOutgoingProjectedRetained
    );
    //console.log()
    console.log(
      'teamTwoOutgoingProjectedRetained' + teamTwoOutgoingProjectedRetained
    );

    //calculate the cap space for each team
    let teamOneCapPostTrade =
      this.state.teamOneCap[year].cap -
      (teamOneOutgoingProjectedRemaining - teamTwoOutgoingProjectedRemaining) +
      (teamOneOutgoingProjectedRetained - teamTwoOutgoingProjectedRetained);
    let teamTwoCapPostTrade =
      this.state.teamTwoCap[year].cap -
      (teamTwoOutgoingProjectedRemaining - teamOneOutgoingProjectedRemaining) +
      (teamTwoOutgoingProjectedRetained - teamOneOutgoingProjectedRetained);
    //let teamOneCapPostTrade = this.state.teamOneCap[year].cap - projectedRemainingDiff;
    //let teamTwoCapPostTrade = this.state.teamTwoCap[year].cap + projectedRemainingDiff;

    console.log('team One teamOneCapPostTrade' + teamOneCapPostTrade);
    console.log('team Two teamTwoCapPostTrade' + teamTwoCapPostTrade);

    //console.log(this.state.teamTwoCap[year].cap);

    //Calculate LTIR info
    /* Realized I forgot step 2 here in calculating `ltir_used` (just setting today_projected_over = 0 if the original value is negative):
`today_projected_over = current_daily_cap - current_acsl`
`today_projected_over = max(0, today_projected_over)`
`projected_over_remaining = today_projected_over * days_remaining`
`projected_over_amt = over_to_date + projected_over_remaining`
`this_instance_ltir_used = (((current_acsl - cap_ceiling)/days_in_season) * proj_ltir_length) + projected_over_amt`
`ltir_used = this_instance_ltir_used + ltir_used_nonactive`*/
    let teamOneDailyCap = this.state.teamOneAll.ltir_info.current_daily_cap;
    let teamTwoDailyCap = this.state.teamTwoAll.ltir_info.current_daily_cap;
    //let teamOneLTIRUsed = 0;
    //  let teamTwoLTIRUsed = 0;

    const teamOneOutgoingTotalCap = this.state.teamOneOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        currentPost.contract &&
        currentPost.contract[year] &&
        currentPost.contract[year].cap_hit
          ? totalUpvotes + currentPost.contract[year].cap_hit
          : totalUpvotes, // reducer function
      0 // initial accumulator value
    );
    const teamTwoOutgoingTotalCap = this.state.teamTwoOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        currentPost.contract &&
        currentPost.contract[year] &&
        currentPost.contract[year].cap_hit
          ? totalUpvotes + currentPost.contract[year].cap_hit
          : totalUpvotes, // reducer function
      0 // initial accumulator value
    );
    const teamOneTotalRetained = this.state.teamOneOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        currentPost.retained && currentPost.retained
          ? totalUpvotes + currentPost.retained
          : totalUpvotes, // reducer function
      0 // initial accumulator value
    );
    const teamTwoTotalRetained = this.state.teamTwoOutgoing.reduce(
      (totalUpvotes, currentPost) =>
        currentPost.retained && currentPost.retained
          ? totalUpvotes + currentPost.retained
          : totalUpvotes, // reducer function
      0 // initial accumulator value
    );

    //subtract the values from daily cap
    teamOneDailyCap =
      teamOneDailyCap -
      (teamOneOutgoingTotalCap - teamTwoOutgoingTotalCap) +
      (teamOneTotalRetained - teamTwoTotalRetained);
    teamTwoDailyCap =
      teamTwoDailyCap -
      (teamTwoOutgoingTotalCap - teamOneOutgoingTotalCap) +
      (teamTwoTotalRetained - teamOneTotalRetained);
    //today_projected_over = max(0, today_projected_over)
    //console.log("teamOneDailyCap" + teamOneDailyCap);
    //console.log("this.state.teamOneAll.ltir_info.current_acsl" + this.state.teamOneAll.ltir_info.current_acsl);
    let teamOneDailyCapTodayProjectOver =
      teamOneDailyCap - this.state.teamOneAll.ltir_info.current_acsl;
    let teamTwoDailyCapTodayProjectOver =
      teamTwoDailyCap - this.state.teamTwoAll.ltir_info.current_acsl;
    teamOneDailyCapTodayProjectOver = Math.max(
      0,
      teamOneDailyCapTodayProjectOver / this.state.teamOneAll.days_in_season
    );
    teamTwoDailyCapTodayProjectOver = Math.max(
      0,
      teamTwoDailyCapTodayProjectOver / this.state.teamTwoAll.days_in_season
    );

    //projected_over_remaining = today_projected_over * days_remaining
    //console.log("teamOneDailyCapTodayProjectOver" + teamOneDailyCapTodayProjectOver);
    //console.log("this.state.teamOneAll.days_remaining" + this.state.teamOneAll.days_remaining);
    let teamOneDailyCapTodayProjectOverRemaining =
      teamOneDailyCapTodayProjectOver * this.state.teamOneAll.days_remaining;
    let teamTwoDailyCapTodayProjectOverRemaining =
      teamTwoDailyCapTodayProjectOver * this.state.teamTwoAll.days_remaining;
    //projected_over_amt = over_to_date + projected_over_remaining
    //console.log("this.state.teamOneAll.ltir_info.over_to_date" + this.state.teamOneAll.ltir_info.over_to_date);
    //console.log("teamOneDailyCapTodayProjectOverRemaining" + teamOneDailyCapTodayProjectOverRemaining);
    let teamOneDailyCapTodayProjectOverAmount =
      Math.round(this.state.teamOneAll.ltir_info.over_to_date) +
      teamOneDailyCapTodayProjectOverRemaining;
    let teamTwoDailyCapTodayProjectOverAmount =
      Math.round(this.state.teamTwoAll.ltir_info.over_to_date) +
      teamTwoDailyCapTodayProjectOverRemaining;
    //`this_instance_ltir_used = (((current_acsl - cap_ceiling)/days_in_season) * proj_ltir_length) + projected_over_amt`
    // console.log("this.state.teamOneAll.ltir_info.current_acsl" + this.state.teamOneAll.ltir_info.current_acsl);
    // console.log("this.state.teamOneAll.ltir_info.cap_ceiling" + this.state.teamOneAll.ltir_info.cap_ceiling);
    // console.log("this.state.teamOneAll.days_in_season" + this.state.teamOneAll.days_in_season);
    // console.log("this.state.teamOneAll.ltir_info.proj_ltir_length" + this.state.teamOneAll.ltir_info.proj_ltir_length);
    // console.log("teamOneDailyCapTodayProjectOverAmount" + teamOneDailyCapTodayProjectOverAmount);
    let teamOneThisInstanceLTIRUsed =
      ((this.state.teamOneAll.ltir_info.current_acsl -
        this.state.teamOneAll.ltir_info.cap_ceiling) /
        this.state.teamOneAll.days_in_season) *
        this.state.teamOneAll.ltir_info.proj_ltir_length +
      teamOneDailyCapTodayProjectOverAmount;
    let teamTwoThisInstanceLTIRUsed =
      ((this.state.teamTwoAll.ltir_info.current_acsl -
        this.state.teamTwoAll.ltir_info.cap_ceiling) /
        this.state.teamTwoAll.days_in_season) *
        this.state.teamTwoAll.ltir_info.proj_ltir_length +
      teamTwoDailyCapTodayProjectOverAmount;
    //`ltir_used = this_instance_ltir_used + ltir_used_nonactive`
    console.log('teamOneThisInstanceLTIRUsed' + teamOneThisInstanceLTIRUsed);
    console.log(
      'this.state.teamOneAll.ltir_info.ltir_used_nonactive' +
        this.state.teamOneAll.ltir_info.ltir_used_nonactive
    );
    let teamOneLTIRUsed = parseInt(
      teamOneThisInstanceLTIRUsed +
        this.state.teamOneAll.ltir_info.ltir_used_nonactive
    );
    let teamTwoLTIRUsed = parseInt(
      teamTwoThisInstanceLTIRUsed +
        this.state.teamTwoAll.ltir_info.ltir_used_nonactive
    );

    if (this.state.teamOneAll.ltir_info.active_ltir == false) {
      teamOneLTIRUsed = this.state.teamOneAll.ltir_info.ltir_used_nonactive;
    }
    if (this.state.teamTwoAll.ltir_info.active_ltir == false) {
      teamTwoLTIRUsed = this.state.teamTwoAll.ltir_info.ltir_used_nonactive;
    }

    //Log the transactions
    console.log('teamOneDailyCap' + teamOneDailyCap);
    console.log(
      'this.state.teamOneAll.ltir_info.current_acsl' +
        this.state.teamOneAll.ltir_info.current_acsl
    );
    console.log(
      'teamOneDailyCapTodayProjectOver' + teamOneDailyCapTodayProjectOver
    );
    console.log(
      'this.state.teamOneAll.days_remaining' +
        this.state.teamOneAll.days_remaining
    );
    console.log(
      'this.state.teamOneAll.ltir_info.over_to_date' +
        this.state.teamOneAll.ltir_info.over_to_date
    );
    console.log(
      'teamOneDailyCapTodayProjectOverRemaining' +
        teamOneDailyCapTodayProjectOverRemaining
    );
    console.log(
      'this.state.teamOneAll.ltir_info.current_acsl' +
        this.state.teamOneAll.ltir_info.current_acsl
    );
    console.log(
      'this.state.teamOneAll.ltir_info.cap_ceiling' +
        this.state.teamOneAll.ltir_info.cap_ceiling
    );
    console.log(
      'this.state.teamOneAll.days_in_season' +
        this.state.teamOneAll.days_in_season
    );
    console.log(
      'this.state.teamOneAll.ltir_info.proj_ltir_length' +
        this.state.teamOneAll.ltir_info.proj_ltir_length
    );
    console.log(
      'teamOneDailyCapTodayProjectOverAmount' +
        teamOneDailyCapTodayProjectOverAmount
    );
    console.log('teamOneThisInstanceLTIRUsed' + teamOneThisInstanceLTIRUsed);
    console.log(
      'this.state.teamOneAll.ltir_info.ltir_used_nonactive' +
        this.state.teamOneAll.ltir_info.ltir_used_nonactive
    );
    console.log('teamOneLTIRUsed' + teamOneLTIRUsed);
    //Log the transactions
    console.log('teamTwoDailyCap' + teamTwoDailyCap);
    console.log(
      'this.state.teamTwoAll.ltir_info.current_acsl' +
        this.state.teamTwoAll.ltir_info.current_acsl
    );
    console.log(
      'teamTwoDailyCapTodayProjectOver' + teamTwoDailyCapTodayProjectOver
    );
    console.log(
      'this.state.teamTwoAll.days_remaining' +
        this.state.teamTwoAll.days_remaining
    );
    console.log(
      'this.state.teamTwoAll.ltir_info.over_to_date' +
        this.state.teamTwoAll.ltir_info.over_to_date
    );
    console.log(
      'teamTwoDailyCapTodayProjectOverRemaining' +
        teamTwoDailyCapTodayProjectOverRemaining
    );
    console.log(
      'this.state.teamTwoAll.ltir_info.current_acsl' +
        this.state.teamTwoAll.ltir_info.current_acsl
    );
    console.log(
      'this.state.teamTwoAll.ltir_info.cap_ceiling' +
        this.state.teamTwoAll.ltir_info.cap_ceiling
    );
    console.log(
      'this.state.teamTwoAll.days_in_season' +
        this.state.teamTwoAll.days_in_season
    );
    console.log(
      'this.state.teamTwoAll.ltir_info.proj_ltir_length' +
        this.state.teamTwoAll.ltir_info.proj_ltir_length
    );
    console.log(
      'teamTwoDailyCapTodayProjectOverAmount' +
        teamTwoDailyCapTodayProjectOverAmount
    );
    console.log('teamTwoThisInstanceLTIRUsed' + teamTwoThisInstanceLTIRUsed);
    console.log(
      'this.state.teamTwoAll.ltir_info.ltir_used_nonactive' +
        this.state.teamTwoAll.ltir_info.ltir_used_nonactive
    );
    console.log('teamTwoLTIRUsed' + teamTwoLTIRUsed);

    console.log('end of math');

    console.log(
      'Team one cap_ceiling ' + this.state.teamOneAll.ltir_info.cap_ceiling
    );
    console.log('Team one teamOneCapPostTrade ' + teamOneCapPostTrade);
    console.log('Team one teamOneLTIRUsed' + teamOneLTIRUsed);
    let teamOneCapSpace =
      this.state.teamOneAll.ltir_info.cap_ceiling -
      teamOneCapPostTrade +
      teamOneLTIRUsed;
    console.log('Team one cap space ' + teamOneCapSpace);
    let teamTwoCapSpace =
      this.state.teamTwoAll.ltir_info.cap_ceiling -
      teamTwoCapPostTrade +
      teamTwoLTIRUsed;
    console.log(
      'this.state.teamTwoAll.ltir_info.cap_ceiling' +
        this.state.teamTwoAll.ltir_info.cap_ceiling
    );
    console.log('teamTwoCapPostTrade' + teamTwoCapPostTrade);
    console.log('teamTwoLTIRUsed' + teamTwoLTIRUsed);
    console.log('teamTwoCapSpace' + teamTwoCapSpace);
    //Calculate outcomes
    teamOneOutcome[year] = [];
    teamOneOutcome[year].cap_hit = (
      teamTwoOutgoingCap -
      teamOneOutgoingCap +
      (teamOneOutgoingRetained - teamTwoOutgoingRetained)
    ).toLocaleString();
    teamOneOutcome[year].henri = (
      teamOneOutgoingHenri - teamTwoOutgoingHenri
    ).toLocaleString();
    teamOneOutcome[year].surplus = (
      teamOneOutgoingSurplus -
      teamTwoOutgoingSurplus +
      (teamOneOutgoingRetained - teamTwoOutgoingRetained)
    ).toLocaleString();
    teamOneOutcome[year].total = Math.round(
      teamOneCapPostTrade
    ).toLocaleString();
    teamOneOutcome[year].remaining = Math.round(
      teamOneCapSpace
    ).toLocaleString();
    teamOneOutcome[year].ltirUsed = Math.round(
      teamOneLTIRUsed
    ).toLocaleString();

    teamTwoOutcome[year] = [];
    teamTwoOutcome[year].cap_hit = (
      teamOneOutgoingCap -
      teamTwoOutgoingCap +
      (teamTwoOutgoingRetained - teamOneOutgoingRetained)
    ).toLocaleString();
    teamTwoOutcome[year].henri = (
      teamTwoOutgoingHenri - teamOneOutgoingHenri
    ).toLocaleString();
    teamTwoOutcome[year].surplus = (
      teamTwoOutgoingSurplus -
      teamOneOutgoingSurplus +
      (teamTwoOutgoingRetained - teamOneOutgoingRetained)
    ).toLocaleString();
    teamTwoOutcome[year].total = Math.round(
      teamTwoCapPostTrade
    ).toLocaleString();
    teamTwoOutcome[year].remaining = Math.round(
      teamTwoCapSpace
    ).toLocaleString();
    teamTwoOutcome[year].ltirUsed = Math.round(
      teamTwoLTIRUsed
    ).toLocaleString();

    this.setState(prevState => ({
      teamOneOutcome: teamOneOutcome,
      teamTwoOutcome: teamTwoOutcome
    }));
  }
  async recalculate() {
    console.log('recalculate is happening');
    this.recalculateYearOne();
    this.recalculateotherYears();
  }

  async recalculateotherYears() {
    console.log('recalculate');
    let teamOneOutcome = this.state.teamOneOutcome;
    let teamTwoOutcome = this.state.teamTwoOutcome;
    for (var year = 1; year < 3; year++) {
      const totalRetained = this.state.teamTwoOutgoing.reduce(
        (totalUpvotes, currentPost) =>
          currentPost.retained && currentPost.retained
            ? totalUpvotes + currentPost.retained
            : totalUpvotes, // reducer function
        0 // initial accumulator value
      );
      const totalCap = this.state.teamTwoOutgoing.reduce(
        (totalUpvotes, currentPost) =>
          currentPost.contract &&
          currentPost.contract[year] &&
          currentPost.contract[year].cap_hit
            ? totalUpvotes + currentPost.contract[year].cap_hit
            : totalUpvotes, // reducer function
        0 // initial accumulator value
      );
      //console.log("totalCap" + totalCap);
      const totalHenri = this.state.teamTwoOutgoing.reduce(
        (totalUpvotes, currentPost) =>
          currentPost.contract &&
          currentPost.contract[year] &&
          currentPost.contract[year].henri
            ? totalUpvotes - currentPost.contract[year].henri
            : totalUpvotes, // reducer function
        0 // initial accumulator value
      );
      const totalSurplus = this.state.teamTwoOutgoing.reduce(
        (totalUpvotes, currentPost) =>
          currentPost.contract &&
          currentPost.contract[year] &&
          currentPost.contract[year].surplus
            ? totalUpvotes - currentPost.contract[year].surplus
            : totalUpvotes, // reducer function
        0 // initial accumulator value
      );

      const totalCapTwo = this.state.teamOneOutgoing.reduce(
        (totalUpvotes, currentPost) =>
          currentPost.contract &&
          currentPost.contract[year] &&
          currentPost.contract[0].cap_hit
            ? totalUpvotes + currentPost.contract[year].cap_hit
            : totalUpvotes, // reducer function
        0 // initial accumulator value
      );
      const totalRetainedTwo = this.state.teamOneOutgoing.reduce(
        (totalUpvotes, currentPost) =>
          currentPost.retained && currentPost.retained
            ? totalUpvotes + currentPost.retained
            : totalUpvotes, // reducer function
        0 // initial accumulator value
      );
      const totalHenriTwo = this.state.teamOneOutgoing.reduce(
        (totalUpvotes, currentPost) =>
          currentPost.contract &&
          currentPost.contract[year] &&
          currentPost.contract[0].henri
            ? totalUpvotes - currentPost.contract[year].henri
            : totalUpvotes, // reducer function
        0 // initial accumulator value
      );
      const totalSurplusTwo = this.state.teamOneOutgoing.reduce(
        (totalUpvotes, currentPost) =>
          currentPost.contract &&
          currentPost.contract[year] &&
          currentPost.contract[0].surplus
            ? totalUpvotes - currentPost.contract[year].surplus
            : totalUpvotes, // reducer function
        0 // initial accumulator value
      );

      console.log('total retained' + totalRetained);
      console.log('total retained two' + totalRetainedTwo);
      console.log(totalCap);
      console.log(totalCapTwo);
      //let retained
      //Calculate outcomes
      teamOneOutcome[year] = [];
      teamOneOutcome[year].cap_hit = (
        totalCap -
        totalCapTwo +
        (totalRetainedTwo - totalRetained)
      ).toLocaleString();
      teamOneOutcome[year].henri = (
        totalHenriTwo - totalHenri
      ).toLocaleString();
      teamOneOutcome[year].surplus = (
        totalSurplusTwo -
        totalSurplus -
        (totalRetainedTwo - totalRetained)
      ).toLocaleString();
      teamOneOutcome[year].total = (
        this.state.teamOneCap[year].cap +
        (totalCap - totalCapTwo + (totalRetainedTwo - totalRetained))
      ).toLocaleString();
      teamOneOutcome[year].remaining = (
        this.state.teamOneCap[year].cap_ceiling -
        (this.state.teamOneCap[year].cap +
          (totalCap - totalCapTwo + (totalRetainedTwo - totalRetained)))
      ).toLocaleString();
      console.log(
        'this.state.teamOneCap[year].cap' + this.state.teamOneCap[year].cap
      );
      console.log(
        'this.state.teamOneCap[year].cap_ceiling' +
          this.state.teamOneCap[year].cap_ceiling
      );
      console.log('totalCap' + totalCap);
      console.log('totalCapTwo' + totalCapTwo);
      console.log('totalRetainedTwo' + totalRetainedTwo);
      console.log('totalRetained' + totalRetained);
      teamTwoOutcome[year] = [];
      teamTwoOutcome[year].cap_hit = (
        totalCapTwo -
        totalCap +
        (totalRetained - totalRetainedTwo)
      ).toLocaleString();
      teamTwoOutcome[year].henri = (
        totalHenri - totalHenriTwo
      ).toLocaleString();
      teamTwoOutcome[year].surplus = (
        totalSurplus -
        totalSurplusTwo -
        (totalRetained - totalRetainedTwo)
      ).toLocaleString();
      teamTwoOutcome[year].total = (
        this.state.teamTwoCap[year].cap +
        (totalCapTwo - totalCap + (totalRetained - totalRetainedTwo))
      ).toLocaleString();
      console.log(year);
      console.log(
        'this years total cap' + this.state.teamTwoCap[year].current_cap_space
      );
      console.log(
        'in out math' +
          (totalCapTwo - totalCap + (totalRetained - totalRetainedTwo))
      );
      teamTwoOutcome[year].remaining = (
        this.state.teamTwoCap[year].cap_ceiling -
        (this.state.teamTwoCap[year].cap +
          (totalCapTwo - totalCap + (totalRetained - totalRetainedTwo)))
      ).toLocaleString();
    }
    this.setState(prevState => ({
      teamOneOutcome: teamOneOutcome,
      teamTwoOutcome: teamTwoOutcome
    }));
  }

  handleClose(e) {
    this.setState({ open: false, openLoad: false });
  }
  handleCloseSave(e) {
    this.setState({ open: false, openSave: false });
  }
  addAsset(item, index, incomingTeam) {
    console.log(
      'ASSET' + JSON.stringify(this.state.selectedAsset) + ' index' + index
    );
    //console.log("team" + incomingTeam);
    //let team = incomingTeam === 1 ? "teamOneOutgoing" : "teamTwoOutgoing";
    console.log(item, index, incomingTeam);
    if (!this.state.selectedAsset) {
      if (incomingTeam === 1) {
        let oldIncoming = this.state.teamOneOutgoing;
        oldIncoming[index] = '';
        this.setState(prevState => ({
          teamOneOutgoing: oldIncoming
        }));
      } else if (incomingTeam === 2) {
        console.log('incoming team is 2');
        let oldIncoming = this.state.teamTwoOutgoing;
        oldIncoming[index] = '';
        this.setState(prevState => ({
          teamTwoOutgoing: oldIncoming
        }));
      }
      this.recalculate();
      return;
    }
    ////console.log("clickeD" + JSON.stringify(item));
    //selectedAsset.push(item);
    if (
      incomingTeam === 1 &&
      this.state.teamOneAssets.find(x => x === this.state.selectedAsset)
    ) {
      let oldIncoming = this.state.teamOneOutgoing;
      oldIncoming[index] = this.state.selectedAsset;
      //console.log("old incoming " + JSON.stringify(oldIncoming));
      this.setState(prevState => ({
        teamOneOutgoing: oldIncoming,
        selectedAsset: ''
      }));
    } else if (
      incomingTeam === 2 &&
      this.state.teamTwoAssets.find(x => x === this.state.selectedAsset)
    ) {
      let oldIncoming = this.state.teamTwoOutgoing;
      oldIncoming[index] = this.state.selectedAsset;
      //console.log("old incoming " + JSON.stringify(oldIncoming));
      this.setState(prevState => ({
        teamTwoOutgoing: oldIncoming,
        selectedAsset: ''
      }));
    }
    this.recalculate();
  }

  handleNameChange(event) {
    this.setState({ tradeName: event.target.value });
  }

  render() {
    ////console.log(JSON.stringify(this.state.teamOneAssets)) ;
    ////console.log(JSON.stringify(this.state.teamOneAssets.filter(asset => asset.asset_type === "player")));
    return (
      <div>
        <header className="nav">
          <CustomNav />
          <ScenarioHeader />
        </header>
        <div
          className="flex-grid"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: '',
            padding: '1em'
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <select
                className="trd-trade-asset-dropdown-box"
                onChange={e => this.changeTeam(e.target.value, 'home', false)}
              >
                <AppContext.Consumer>
                  {context =>
                    context.number.map(item => (
                      <option
                        selected={this.state.homeTeam === item.abbreviation}
                        value={item.abbreviation}
                      >
                        {item.full_team_name}
                      </option>
                    ))
                  }
                </AppContext.Consumer>
              </select>
              <div className="saveDiv">
                <button
                  href="#save"
                  className="saveButton"
                  ref={node => {
                    this.target2 = node;
                  }}
                  style={{
                    maxHeight: '35px',
                    fontSize: '14px',
                    marginBottom: '3px',
                    padding: '4px 10px 7px 10px'
                  }}
                  className="header-account-button"
                  onClick={this.openSaveTrade}
                >
                  Save Trade
                </button>
                <Popover
                  placement="bottom"
                  container={this}
                  target={this.target2}
                  show={this.state.openSave}
                  onHide={this.handleCloseSave.bind(this)}
                >
                  <div>
                    <h4>Enter a Trade name:</h4>
                    <input
                      style={{ marginBottom: '15px' }}
                      type="text"
                      value={this.state.tradeName}
                      onChange={this.handleNameChange}
                    />
                    <button
                      style={{
                        maxHeight: '35px',
                        fontSize: '14px',
                        marginBottom: '3px',
                        padding: '4px 10px 7px 10px'
                      }}
                      className="header-account-button"
                      onClick={this.saveTrade}
                    >
                      Save Trade
                    </button>
                  </div>
                </Popover>
              </div>
              <strong style={{ fontSize: '18px', color: 'white' }}>
                {this.state.homeTeam}
              </strong>
            </div>
            <div className="trd-trade-asset-filter">
              <strong>SELECT ASSET</strong>
              <div className="radioButton">
                <label>Players</label>
                <input
                  type="radio"
                  name="asset"
                  value="player"
                  checked={this.state.teamOneAssetType === 'player'}
                  onChange={this.handleteamOneAssetTypeChange}
                />
              </div>
              <div className="radioButton">
                <label>Prospects</label>
                <input
                  type="radio"
                  name="asset"
                  value="prospect"
                  checked={this.state.teamOneAssetType === 'prospect'}
                  onChange={this.handleteamOneAssetTypeChange}
                />
              </div>
              <div className="radioButton">
                <label>Picks</label>
                <input
                  type="radio"
                  name="asset"
                  value="pick"
                  checked={this.state.teamOneAssetType === 'pick'}
                  onChange={this.handleteamOneAssetTypeChange}
                />
              </div>
            </div>
            <div>
              <ReactTable
                style={{ maxHeight: '45em' }}
                ref="teamOneTable"
                toggleActive={this.props.toggleActive}
                data={this.state.teamOneAssets.filter(
                  asset => asset.asset_type === this.state.teamOneAssetType
                )}
                showPagination={false}
                defaultFilterMethod={(filter, row) =>
                  String(row[filter.id]) === filter.value
                }
                getTrProps={(state, rowInfo, column, instance, data) => ({
                  onClick: () => {
                    this.activateLasers(rowInfo.original);
                  }
                })}
                noDataText={
                  <FadeLoader color={'#123abc'} loading={this.state.loading} />
                }
                getNoDataProps={(state, rowInfo, column, instance) => {
                  return { style: { background: 'none' } };
                }}
                columns={this.state.teamOneColumns}
                pageSize={this.state.teamOnePageSize}
                resizable={false}
                className="-striped -highlight NonRostered TradeTable"
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 2,
              margin: '0 1em'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              {/*<div className="trd-trade-term-tab" style={{margin: '0.5em 2em'}} onClick={(e) => this.saveTrade(e)}>SAVE THIS TRADE</div>
                    <div className="trd-trade-term-tab" style={{margin: '0.5em 2em'}} onClick={(e) => this.loadTrade(e)}>LOAD SAVED TRADE</div>*/}
            </div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div
                className="trd-trade-receive-box"
                style={{ backgroundColor: 'white' }}
              >
                <div
                  className="trd-trade-receive-header"
                  style={{ display: 'flex' }}
                >
                  <div style={{ flex: '4' }}>{this.state.homeTeam} SENDS:</div>
                  <div style={{ flex: '1' }}>Retain</div>
                </div>
                <div className="trd-trade-receive-listing">
                  {this.state.teamOneOutgoing.map((item, index) => (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <div
                        onClick={() => this.addAsset(item, index, 1)}
                        style={{
                          borderBottom: '1px  solid grey',
                          flex: '10',
                          minHeight: '20px',
                          minWidth: '60px'
                        }}
                      >
                        {this.getAssetDescription(item)}
                      </div>
                      <input
                        style={{ flex: '4', fontSize: '10px' }}
                        type="number"
                        className="form-control"
                        name="username"
                        value={item.retained || ''}
                        onChange={e => {
                          this.handleChange(e, item, index, 1);
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div
                className="trd-trade-receive-box"
                style={{ backgroundColor: 'white' }}
              >
                <div
                  className="trd-trade-receive-header"
                  style={{ display: 'flex' }}
                >
                  <div style={{ flex: '4' }}>{this.state.awayTeam} SENDS:</div>
                  <div style={{ flex: '1' }}>Retain</div>
                </div>
                <div className="trd-trade-receive-listing">
                  {this.state.teamTwoOutgoing.map((item, index) => (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <div
                        onClick={() => this.addAsset(item, index, 2)}
                        style={{
                          borderBottom: '1px  solid grey',
                          minHeight: '20px',
                          minWidth: '60px',
                          flex: '10'
                        }}
                      >
                        {this.getAssetDescription(item)}
                      </div>
                      <input
                        style={{ flex: '4' }}
                        type="number"
                        className="form-control"
                        name="username"
                        value={item.retained || ''}
                        onChange={e => {
                          this.handleChange(e, item, index, 2);
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="trd-trade-term-box">
              <div
                className="trd-trade-term-tab"
                onClick={this.modifyTerm.bind(this, 1)}
                style={{
                  backgroundColor:
                    this.state.termLength === 1 ? '#082539' : '#324d67'
                }}
              >
                <span style={{ fontSize: '1.1em' }}>Short-Term</span>
                <br />
                (1-YR Return)
              </div>
              <div
                className="trd-trade-term-tab"
                onClick={this.modifyTerm.bind(this, 2)}
                style={{
                  backgroundColor:
                    this.state.termLength === 2 ? '#082539' : '#324d67'
                }}
              >
                <span style={{ fontSize: '1.1em' }}>Medium-Term</span>
                <br />
                (2 YR Return)
              </div>
              <div
                className="trd-trade-term-tab"
                onClick={this.modifyTerm.bind(this, 3)}
                style={{
                  backgroundColor:
                    this.state.termLength === 3 ? '#082539' : '#324d67'
                }}
              >
                <span style={{ fontSize: '1.1em' }}>Long-Term</span>
                <br />
                (3-YR Return)
              </div>
            </div>
            <div
              style={{ display: 'flex', flexDirection: 'row', margin: '0 1em' }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '50%'
                }}
              >
                <div className="trd-trade-value-impact-box">
                  <div className="trd-trade-value-impact-column trd-value-impact-title-column">
                    <div className="trd-trade-value-impact-header">VALUE</div>
                    <div className="trd-trade-value-impact-item">CAP HIT</div>
                    <div className="trd-trade-value-impact-item">HENRI</div>
                    <div className="trd-trade-value-impact-item">SURPLUS</div>
                  </div>
                  <div className="trd-trade-value-impact-column">
                    <div className="trd-trade-value-impact-header">
                      NET RETURN
                    </div>
                    {(this.state.teamOneOutcome[this.state.termLength - 1] && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            getCapColour(
                              this.state.teamTwoOutcome[
                                this.state.termLength - 1
                              ].cap_hit
                            )
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamOneOutcome[this.state.termLength - 1]
                            .cap_hit
                        }
                      </div>
                    )) || <div className="trd-trade-value-impact-item">$0</div>}
                    {(this.state.teamOneOutcome[this.state.termLength - 1] && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            getCapColour(
                              this.state.teamOneOutcome[
                                this.state.termLength - 1
                              ].henri
                            )
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamOneOutcome[this.state.termLength - 1]
                            .henri
                        }
                      </div>
                    )) || <div className="trd-trade-value-impact-item">$0</div>}
                    {(this.state.teamOneOutcome[this.state.termLength - 1] && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            getCapColour(
                              this.state.teamOneOutcome[
                                this.state.termLength - 1
                              ].surplus
                            )
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamOneOutcome[this.state.termLength - 1]
                            .surplus
                        }
                      </div>
                    )) || <div className="trd-trade-value-impact-item">$0</div>}
                  </div>
                </div>
                <div
                  className="trd-trade-value-impact-header"
                  style={{ marginTop: '0.5em' }}
                >
                  2018-19 PROJECTED CAP IMPACT
                </div>
                <div
                  className="trd-trade-value-impact-box"
                  style={{ marginTop: 0 }}
                >
                  <div className="trd-trade-value-impact-column trd-value-impact-title-column">
                    <div className="trd-trade-value-impact-item">
                      TOTAL CAP HIT
                    </div>
                    <div className="trd-trade-value-impact-item">LTIR USED</div>
                    <div className="trd-trade-value-impact-item">CAP SPACE</div>
                  </div>
                  <div className="trd-trade-value-impact-column">
                    {(this.state.teamOneOutcome[this.state.termLength - 1] && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            getCapColour(
                              this.state.teamOneOutcome[
                                this.state.termLength - 1
                              ].remaining
                            )
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamOneOutcome[this.state.termLength - 1]
                            .total
                        }
                      </div>
                    )) || <div className="trd-trade-value-impact-item">$0</div>}

                    {(this.state.teamOneOutcome[this.state.termLength - 1] &&
                      this.state.teamOneOutcome[this.state.termLength - 1]
                        .ltirUsed && (
                        <div
                          className="trd-trade-value-impact-item"
                          style={{
                            backgroundColor: getHenriStyle(
                              getCapColour(
                                this.state.teamOneOutcome[
                                  this.state.termLength - 1
                                ].ltirUsed
                              )
                            )
                          }}
                        >
                          $
                          {
                            this.state.teamOneOutcome[this.state.termLength - 1]
                              .ltirUsed
                          }
                        </div>
                      )) || (
                      <div className="trd-trade-value-impact-item">$0</div>
                    )}
                    {(this.state.teamOneOutcome[this.state.termLength - 1] && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            getCapColour(
                              this.state.teamOneOutcome[
                                this.state.termLength - 1
                              ].remaining
                            )
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamOneOutcome[this.state.termLength - 1]
                            .remaining
                        }
                      </div>
                    )) || <div className="trd-trade-value-impact-item">$0</div>}
                  </div>
                </div>
                <div
                  className="trd-trade-value-impact-header"
                  style={{ marginTop: '0.5em' }}
                >
                  BONUSES
                </div>
                <div
                  className="trd-trade-value-impact-box"
                  style={{ marginTop: 0 }}
                >
                  <div className="trd-trade-value-impact-column trd-value-impact-title-column">
                    <div className="trd-trade-value-impact-item">PLAYER</div>
                    {this.state.teamTwoOutgoing.length > 0 &&
                      (this.state.teamTwoOutgoing[0].asset_type === 'player' ||
                        this.state.teamTwoOutgoing[0].asset_type ===
                          'prospect') && (
                        <div className="trd-trade-value-impact-item">
                          {this.state.teamTwoOutgoing[0].first_name[0] +
                            '. ' +
                            this.state.teamTwoOutgoing[0].last_name}
                        </div>
                      )}
                    {this.state.teamTwoOutgoing.length > 1 &&
                      (this.state.teamTwoOutgoing[1].asset_type === 'player' ||
                        this.state.teamTwoOutgoing[1].asset_type ===
                          'prospect') && (
                        <div className="trd-trade-value-impact-item">
                          {this.state.teamTwoOutgoing[1].first_name[0] +
                            '. ' +
                            this.state.teamTwoOutgoing[1].last_name}
                        </div>
                      )}
                    {this.state.teamTwoOutgoing.length > 2 &&
                      (this.state.teamTwoOutgoing[2].asset_type === 'player' ||
                        this.state.teamTwoOutgoing[2].asset_type ===
                          'prospect') && (
                        <div className="trd-trade-value-impact-item">
                          {this.state.teamTwoOutgoing[2].first_name[0] +
                            '. ' +
                            this.state.teamTwoOutgoing[2].last_name}
                        </div>
                      )}
                    {this.state.teamTwoOutgoing.length > 3 &&
                      (this.state.teamTwoOutgoing[3].asset_type === 'player' ||
                        this.state.teamTwoOutgoing[3].asset_type ===
                          'prospect') && (
                        <div className="trd-trade-value-impact-item">
                          {this.state.teamTwoOutgoing[3].first_name[0] +
                            '. ' +
                            this.state.teamTwoOutgoing[3].last_name}
                        </div>
                      )}
                    {this.state.teamTwoOutgoing.length > 4 &&
                      (this.state.teamTwoOutgoing[4].asset_type === 'player' ||
                        this.state.teamTwoOutgoing[4].asset_type ===
                          'prospect') && (
                        <div className="trd-trade-value-impact-item">
                          {this.state.teamTwoOutgoing[4].first_name[0] +
                            '. ' +
                            this.state.teamTwoOutgoing[4].last_name}
                        </div>
                      )}
                  </div>
                  <div className="trd-trade-value-impact-column">
                    <div className="trd-trade-value-impact-header">
                      PERF BONUS
                    </div>
                    {(this.state.teamTwoOutgoing[0].asset_type === 'player' ||
                      this.state.teamTwoOutgoing[0].asset_type ===
                        'prospect') && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            this.state.teamTwoOutgoing[0].contract[
                              this.state.termLength - 1
                            ].perf_bonus
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamTwoOutgoing[0].contract[
                            this.state.termLength - 1
                          ].perf_bonus
                        }
                      </div>
                    )}
                    {(this.state.teamTwoOutgoing[1].asset_type === 'player' ||
                      this.state.teamTwoOutgoing[1].asset_type ===
                        'prospect') && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            this.state.teamTwoOutgoing[1].contract[
                              this.state.termLength - 1
                            ].perf_bonus
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamTwoOutgoing[1].contract[
                            this.state.termLength - 1
                          ].perf_bonus
                        }
                      </div>
                    )}
                    {(this.state.teamTwoOutgoing[2].asset_type === 'player' ||
                      this.state.teamTwoOutgoing[2].asset_type ===
                        'prospect') && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            this.state.teamTwoOutgoing[2].contract[
                              this.state.termLength - 1
                            ].perf_bonus
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamTwoOutgoing[2].contract[
                            this.state.termLength - 1
                          ].perf_bonus
                        }
                      </div>
                    )}
                    {(this.state.teamTwoOutgoing[3].asset_type === 'player' ||
                      this.state.teamTwoOutgoing[3].asset_type ===
                        'prospect') && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            this.state.teamTwoOutgoing[3].contract[
                              this.state.termLength - 1
                            ].perf_bonus
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamTwoOutgoing[3].contract[
                            this.state.termLength - 1
                          ].perf_bonus
                        }
                      </div>
                    )}
                    {(this.state.teamTwoOutgoing[4].asset_type === 'player' ||
                      this.state.teamTwoOutgoing[4].asset_type ===
                        'prospect') && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            this.state.teamTwoOutgoing[4].contract[
                              this.state.termLength - 1
                            ].perf_bonus
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamTwoOutgoing[4].contract[
                            this.state.termLength - 1
                          ].perf_bonus
                        }
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '50%'
                }}
              >
                <div className="trd-trade-value-impact-box">
                  <div className="trd-trade-value-impact-column trd-value-impact-title-column">
                    <div className="trd-trade-value-impact-header">VALUE</div>
                    <div className="trd-trade-value-impact-item">CAP HIT</div>
                    <div className="trd-trade-value-impact-item">HENRI</div>
                    <div className="trd-trade-value-impact-item">SURPLUS</div>
                  </div>
                  <div className="trd-trade-value-impact-column">
                    <div className="trd-trade-value-impact-header">
                      NET RETURN
                    </div>
                    {(this.state.teamTwoOutcome[this.state.termLength - 1] && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            getCapColour(
                              this.state.teamOneOutcome[
                                this.state.termLength - 1
                              ].cap_hit
                            )
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamTwoOutcome[this.state.termLength - 1]
                            .cap_hit
                        }
                      </div>
                    )) || <div className="trd-trade-value-impact-item">$0</div>}
                    {(this.state.teamTwoOutcome[this.state.termLength - 1] && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            getCapColour(
                              this.state.teamTwoOutcome[
                                this.state.termLength - 1
                              ].henri
                            )
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamTwoOutcome[this.state.termLength - 1]
                            .henri
                        }
                      </div>
                    )) || <div className="trd-trade-value-impact-item">$0</div>}
                    {(this.state.teamTwoOutcome[this.state.termLength - 1] && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            getCapColour(
                              this.state.teamTwoOutcome[
                                this.state.termLength - 1
                              ].surplus
                            )
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamTwoOutcome[this.state.termLength - 1]
                            .surplus
                        }
                      </div>
                    )) || <div className="trd-trade-value-impact-item">$0</div>}
                  </div>
                </div>
                <div
                  className="trd-trade-value-impact-header"
                  style={{ marginTop: '0.5em' }}
                >
                  2018-19 PROJECTED CAP IMPACT
                </div>
                <div
                  className="trd-trade-value-impact-box"
                  style={{ marginTop: 0 }}
                >
                  <div className="trd-trade-value-impact-column trd-value-impact-title-column">
                    <div className="trd-trade-value-impact-item">
                      TOTAL CAP HIT
                    </div>
                    <div className="trd-trade-value-impact-item">LTIR USED</div>
                    <div className="trd-trade-value-impact-item">CAP SPACE</div>
                  </div>
                  <div className="trd-trade-value-impact-column">
                    {(this.state.teamOneOutcome[this.state.termLength - 1] && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            getCapColour(
                              this.state.teamTwoOutcome[
                                this.state.termLength - 1
                              ].remaining
                            )
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamTwoOutcome[this.state.termLength - 1]
                            .total
                        }
                      </div>
                    )) || <div className="trd-trade-value-impact-item">$0</div>}

                    {(this.state.teamOneOutcome[this.state.termLength - 1] &&
                      this.state.teamOneOutcome[this.state.termLength - 1]
                        .ltirUsed && (
                        <div
                          className="trd-trade-value-impact-item"
                          style={{
                            backgroundColor: getHenriStyle(
                              getCapColour(
                                this.state.teamTwoOutcome[
                                  this.state.termLength - 1
                                ].ltirUsed
                              )
                            )
                          }}
                        >
                          $
                          {
                            this.state.teamTwoOutcome[this.state.termLength - 1]
                              .ltirUsed
                          }
                        </div>
                      )) || (
                      <div className="trd-trade-value-impact-item">$0</div>
                    )}
                    {(this.state.teamOneOutcome[this.state.termLength - 1] && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            getCapColour(
                              this.state.teamTwoOutcome[
                                this.state.termLength - 1
                              ].remaining
                            )
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamTwoOutcome[this.state.termLength - 1]
                            .remaining
                        }
                      </div>
                    )) || <div className="trd-trade-value-impact-item">$0</div>}
                  </div>
                </div>
                <div
                  className="trd-trade-value-impact-header"
                  style={{ marginTop: '0.5em' }}
                >
                  BONUSES
                </div>
                <div
                  className="trd-trade-value-impact-box"
                  style={{ marginTop: 0 }}
                >
                  <div className="trd-trade-value-impact-column trd-value-impact-title-column">
                    <div className="trd-trade-value-impact-item">PLAYER</div>
                    {(this.state.teamOneOutgoing[0].asset_type === 'player' ||
                      this.state.teamOneOutgoing[0].asset_type ===
                        'prospect') && (
                      <div className="trd-trade-value-impact-item">
                        {this.state.teamOneOutgoing[0].first_name[0] +
                          '. ' +
                          this.state.teamOneOutgoing[0].last_name}
                      </div>
                    )}
                    {(this.state.teamOneOutgoing[1].asset_type === 'player' ||
                      this.state.teamOneOutgoing[1].asset_type ===
                        'prospect') && (
                      <div className="trd-trade-value-impact-item">
                        {this.state.teamOneOutgoing[1].first_name[0] +
                          '. ' +
                          this.state.teamOneOutgoing[1].last_name}
                      </div>
                    )}
                    {(this.state.teamOneOutgoing[2].asset_type === 'player' ||
                      this.state.teamOneOutgoing[2].asset_type ===
                        'prospect') && (
                      <div className="trd-trade-value-impact-item">
                        {this.state.teamOneOutgoing[2].first_name[0] +
                          '. ' +
                          this.state.teamOneOutgoing[2].last_name}
                      </div>
                    )}
                    {(this.state.teamOneOutgoing[3].asset_type === 'player' ||
                      this.state.teamOneOutgoing[3].asset_type ===
                        'prospect') && (
                      <div className="trd-trade-value-impact-item">
                        {this.state.teamOneOutgoing[3].first_name[0] +
                          '. ' +
                          this.state.teamOneOutgoing[3].last_name}
                      </div>
                    )}
                    {(this.state.teamOneOutgoing[4].asset_type === 'player' ||
                      this.state.teamOneOutgoing[4].asset_type ===
                        'prospect') && (
                      <div className="trd-trade-value-impact-item">
                        {this.state.teamOneOutgoing[4].first_name[0] +
                          '. ' +
                          this.state.teamOneOutgoing[4].last_name}
                      </div>
                    )}
                  </div>
                  <div className="trd-trade-value-impact-column">
                    <div className="trd-trade-value-impact-header">
                      PERF BONUS
                    </div>
                    {(this.state.teamOneOutgoing[0].asset_type === 'player' ||
                      this.state.teamOneOutgoing[0].asset_type ===
                        'prospect') && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            this.state.teamOneOutgoing[0].contract[
                              this.state.termLength - 1
                            ].perf_bonus
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamOneOutgoing[0].contract[
                            this.state.termLength - 1
                          ].perf_bonus
                        }
                      </div>
                    )}
                    {(this.state.teamOneOutgoing[1].asset_type === 'player' ||
                      this.state.teamOneOutgoing[1].asset_type ===
                        'prospect') && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            this.state.teamOneOutgoing[1].contract[
                              this.state.termLength - 1
                            ].perf_bonus
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamOneOutgoing[1].contract[
                            this.state.termLength - 1
                          ].perf_bonus
                        }
                      </div>
                    )}
                    {(this.state.teamOneOutgoing[2].asset_type === 'player' ||
                      this.state.teamOneOutgoing[2].asset_type ===
                        'prospect') && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            this.state.teamOneOutgoing[2].contract[
                              this.state.termLength - 1
                            ].perf_bonus
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamOneOutgoing[2].contract[
                            this.state.termLength - 1
                          ].perf_bonus
                        }
                      </div>
                    )}
                    {(this.state.teamOneOutgoing[3].asset_type === 'player' ||
                      this.state.teamOneOutgoing[3].asset_type ===
                        'prospect') && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            this.state.teamOneOutgoing[3].contract[
                              this.state.termLength - 1
                            ].perf_bonus
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamOneOutgoing[3].contract[
                            this.state.termLength - 1
                          ].perf_bonus
                        }
                      </div>
                    )}
                    {(this.state.teamOneOutgoing[4].asset_type === 'player' ||
                      this.state.teamOneOutgoing[4].asset_type ===
                        'prospect') && (
                      <div
                        className="trd-trade-value-impact-item"
                        style={{
                          backgroundColor: getHenriStyle(
                            this.state.teamOneOutgoing[4].contract[
                              this.state.termLength - 1
                            ].perf_bonus
                          )
                        }}
                      >
                        $
                        {
                          this.state.teamOneOutgoing[4].contract[
                            this.state.termLength - 1
                          ].perf_bonus
                        }
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div>
              {this.state.selectedPlayer && (
                <PlayerCard selectedPlayer={this.state.selectedPlayer} />
              )}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <strong style={{ fontSize: '18px', color: 'white' }}>
                {this.state.awayTeam}
              </strong>
              <div>
                <button
                  href="#"
                  className="button"
                  ref={node => {
                    this.target = node;
                  }}
                  style={{
                    maxHeight: '35px',
                    fontSize: '14px',
                    marginBottom: '3px',
                    padding: '4px 10px 7px 10px'
                  }}
                  className="header-account-button"
                  onClick={this.loadTrades}
                >
                  Load Trade
                </button>

                <Popover
                  placement="bottom"
                  container={this}
                  target={this.target}
                  show={this.state.openLoad}
                  onHide={this.handleClose}
                >
                  {this.state.tradeLoading && (
                    <FadeLoader
                      color={'#123abc'}
                      loading={this.state.tradeLoading}
                    />
                  )}
                  {!this.state.tradeLoading &&
                    this.state.saved_trades.map(file => (
                      <div
                        style={{ borderBottom: '1px black solid' }}
                        onClick={this.loadTrade.bind(file, file)}
                      >
                        <div>{file.trade_desc}</div>
                        <div>{file.saved_date}</div>
                        <div>
                          {file.team_one} and {file.team_two}
                        </div>
                      </div>
                    ))}
                </Popover>
              </div>
              <select
                className="trd-trade-asset-dropdown-box"
                onChange={e => this.changeTeam(e.target.value, 'away', false)}
              >
                <AppContext.Consumer>
                  {context =>
                    context.number.map(item => (
                      <option value={item.abbreviation}>
                        {item.full_team_name}
                      </option>
                    ))
                  }
                </AppContext.Consumer>
              </select>
            </div>
            <div className="trd-trade-asset-filter">
              <strong>SELECT ASSET</strong>
              <div className="radioButton">
                <label>Players</label>
                <input
                  type="radio"
                  name="asset2"
                  value="player"
                  checked={this.state.teamTwoAssetType === 'player'}
                  onChange={this.handleteamTwoAssetTypeChange}
                />
              </div>
              <div className="radioButton">
                <label>Prospects</label>
                <input
                  type="radio"
                  name="asset2"
                  value="prospect"
                  checked={this.state.teamTwoAssetType === 'prospect'}
                  onChange={this.handleteamTwoAssetTypeChange}
                />
              </div>
              <div className="radioButton">
                <label>Picks</label>
                <input
                  type="radio"
                  name="asset2"
                  value="pick"
                  checked={this.state.teamTwoAssetType === 'pick'}
                  onChange={this.handleteamTwoAssetTypeChange}
                />
              </div>
            </div>
            <div>
              <ReactTable
                style={{ maxHeight: '45em' }}
                ref="teamTwoTable"
                toggleActive={this.props.toggleActive}
                data={this.state.teamTwoAssets.filter(
                  asset => asset.asset_type === this.state.teamTwoAssetType
                )}
                showPagination={false}
                defaultFilterMethod={(filter, row) =>
                  String(row[filter.id]) === filter.value
                }
                getTrProps={(state, rowInfo, column, instance, data) => ({
                  onClick: () => this.activateLasers(rowInfo.original)
                })}
                noDataText={
                  <FadeLoader color={'#123abc'} loading={this.state.loading} />
                }
                getNoDataProps={(state, rowInfo, column, instance) => {
                  return { style: { background: 'none', overflow: 'auto' } };
                }}
                columns={this.state.teamTwoColumns}
                pageSize={this.state.teamTwoPageSize}
                resizable={false}
                className="-striped -highlight NonRostered TradeTable"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Trade;



// WEBPACK FOOTER //
// ./src/Pages/Trade.js